"use client";

import { useEffect } from "react";

type McpType = string; // Replace with a more specific union type if possible

export const PushMcpType = ({ mcpType }: { mcpType?: McpType }) => {
  useEffect(() => {
    if (typeof window !== "undefined" && mcpType) {
      window?.dataLayer?.push({ mcp_page_type: mcpType });
    }
  }, [mcpType]);

  return null;
};
